
import { dcFactory } from 'dc';
import CookieSettingsComponent from './js/cookie-settings.component';

dcFactory.register(CookieSettingsComponent);

